(() => {
  'use strict';

  const $ = (selector, scope = document) => scope?.querySelector?.(selector) || null;
  const $$ = (selector, scope = document) => scope?.querySelectorAll ? [...scope.querySelectorAll(selector)] : [];
  const normalizeQty = value => Math.max(1, Math.min(99, Number.parseInt(value, 10) || 1));

  const pending = (element, on) => {
    if (!element) return;
    element.classList.toggle('is-qx-pending', on);
    if ('disabled' in element) element.disabled = on;
    element.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  const initCardForms = (scope = document) => {
    $$('.qx-product-card__form', scope).forEach(form => {
      if (form.dataset.qx251CardReady === 'true') return;
      form.dataset.qx251CardReady = 'true';
      form.dataset.qxCardForm = '';

      const card = form.closest('[data-qx-product-card]');
      const hidden = $('[data-qx-card-form-qty]', form);
      const visible = $('[data-qx-card-qty-input]', card);
      if (!hidden || !visible) return;

      const sync = () => {
        visible.value = normalizeQty(visible.value);
        hidden.value = visible.value;
      };
      sync();
      visible.addEventListener('input', sync);
      visible.addEventListener('change', sync);
    });
  };

  const enhanceCart = (scope = document) => {
    const shell = $('[data-qx-cart-shell]', scope) || (scope.matches?.('[data-qx-cart-shell]') ? scope : null);
    if (!shell) return;

    const count = Number(shell.dataset.cartCount || 0);
    shell.dataset.qxCartState = count === 0 ? 'empty' : count === 1 ? 'single' : 'multi';
    if (count < 2 || document.documentElement.dataset.qx251CartCollapse === 'false') return;

    $$('[data-qx-cart-secondary]', shell).forEach(element => {
      if (element.closest('.qx-cart-secondary-details')) return;
      const details = document.createElement('details');
      details.className = 'qx-cart-secondary-details';
      const summary = document.createElement('summary');
      summary.textContent = element.dataset.qxCartSecondaryLabel || 'More options';
      const inner = document.createElement('div');
      inner.className = 'qx-cart-secondary-inner';
      element.before(details);
      details.append(summary, inner);
      inner.appendChild(element);
    });
  };

  const init = (scope = document) => {
    initCardForms(scope);
    enhanceCart(scope);
  };

  document.addEventListener('submit', event => {
    const form = event.target.closest?.('[data-qx-card-form]');
    if (!form) return;
    const card = form.closest('[data-qx-product-card]');
    const visible = $('[data-qx-card-qty-input]', card);
    const hidden = $('[data-qx-card-form-qty]', form);
    if (hidden) hidden.value = normalizeQty(visible?.value || hidden.value);
    const button = form.querySelector('[type="submit"]');
    pending(button, true);
    setTimeout(() => {
      if (button && document.contains(button)) pending(button, false);
    }, 5000);
  }, true);

  document.addEventListener('click', event => {
    const action = event.target.closest?.('[data-qx-cart-save-later],[data-qx-cart-change-variant],[data-qx-cart-bundle-add],[data-cart-add],[data-cart-checkout]');
    if (!action || action.disabled) return;
    pending(action, true);
    setTimeout(() => {
      if (document.contains(action)) pending(action, false);
    }, 6000);
  }, true);

  document.addEventListener('change', event => {
    const qty = event.target.closest?.('[data-qx-card-qty-input]');
    if (qty) qty.value = normalizeQty(qty.value);
  });

  document.addEventListener('shopify:section:load', event => {
    setTimeout(() => init(event.target || document), 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
})();
